export const DEVICE_AUTH_CODE_SESSION_KEY = 'tempDeviceAuthCode'
export const DEVICE_AUTH_CODE_REMOTE_CLIENT_ID = 'DEVICE_AUTH_CODE_REMOTE_CLIENT_ID'
export const DEVICE_AUTH_CODE_DEVICE_ID = 'DEVICE_AUTH_CODE_DEVICE_ID'

export const DEVICE_AUTH_MODE = {
    UNINITIALIZED: 'UNINITIALIZED',
    X509: 'X509',
    PRE_SHARED_KEY: 'PRE_SHARED_KEY',
}

export const REMOTE_PROVISIONING_MODE = {
    USER_AGENT: 'USER_AGENT',
}

export const GITHUB_VERSION_URL = 'https://api.github.com/repos/plgd-dev/client-application/releases/latest'

export const GITHUB_VERSION_REQUEST_INTERVAL = 30 // in minutes
